<script setup>
import { inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMainStore } from '@/stores/main'
import * as Alerts from '@/services/Alerts'
import * as Server from '@/services/Server'

const group = defineModel()
const store = useMainStore()
const loading = ref(false)

const roundsNumber = ref(1)
const { t } = useI18n()

const addRounds = async () => {
  const n = Number(roundsNumber.value) || 0
  if (n <= 0) return

  if (group.value.group_entries.length == 0) {
    Alerts.warning(t('message.addRoundsNoEntries'))
    return
  }
  
  loading.value = true
  try {
    const path = store.apiPath.rounds_add_many
    const response = await Server.post(path, {
      roundsNumber: n,
      group_id: group.value.id
    })
    group.value.rounds = [...group.value.rounds, ...response.data]
    Alerts.success(t('tournaments.roundsAddedSuccess'))

  } catch (error) {
    console.error('Error adding rounds:', error)
    Alerts.error(error.response?.data?.error || error.message)

  } finally {
    loading.value = false
  }
}

const increment = () => {
  roundsNumber.value = Number(roundsNumber.value) + 1
}

const decrement = () => {
  const v = Number(roundsNumber.value) - 1
  roundsNumber.value = v < 1 ? 1 : v
}
</script>

<template>
  <v-form class="">
    <div class="d-flex align-center mb-4">
      <v-btn icon color="primary" @click="decrement" :disabled="Number(roundsNumber) <= 1"
        variant="tonal"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>

      <div class="mx-3" style="min-width:36px; text-align:center; font-weight:600;">
        {{ roundsNumber }}
      </div>

      <v-btn icon color="primary" @click="increment" variant="tonal">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <v-btn
      color="primary"
      :disabled="!(Number(roundsNumber) > 0)"
      @click="addRounds"
    >
      {{ t('label.add_N_rounds', { n: roundsNumber }) }}
    </v-btn>
  </v-form>
</template>